type APP_ENV =
  | 'local'
  | 'feat'
  | 'dev'
  | 'test'
  | 'uat'
  | 'qa'
  | 'stag'
  | 'canary'
  | 'cana'
  | 'prod';

const environments = [
  'localhost',
  'feat',
  'dev',
  'test',
  'uat',
  'qa',
  'stag',
  'canary',
  'cana',
  'prod',
];

const subdomainSplit = window.location.hostname.split('.')[0].split('-');
const envSuffix = subdomainSplit[subdomainSplit.length - 1];
const currentEnv = environments.includes(envSuffix) ? envSuffix : 'prod';

const config = {
  ENV: currentEnv as APP_ENV,
  VITE_ENV: import.meta.env.VITE_ENV,
  IS_DEV: import.meta.env.DEV,
  MODE: import.meta.env.MODE,
  LOGIN_URL: import.meta.env.VITE_LOGIN_URL,
  // Single API origin. Both SignalR (`${API_URL}/hub/v1`) and the HTTP graph
  // transport (`${API_URL}/graph/*`) are derived from this — there is no
  // separate SignalR URL env var.
  API_URL: import.meta.env.VITE_API_URL,
  PORTAL_VERSION: import.meta.env.VITE_PORTAL_VERSION,
  PORTAL_COMMIT_HASH: import.meta.env.VITE_PORTAL_COMMIT_HASH,
};

export default config;
